import React from 'react';
import { Card, Container, Row, Col, Form, HeaderText, BodyText } from 'shared-portal-component';
import { z } from 'zod';

import '@/components/organism/style.scss';
import { MIN_LEN } from '@/constants';

const schema = z.object({
  emailAddress: z.string().email('Please enter a valid email').nonempty('Email is required'),
});

const fields = [
  {
    name: 'emailAddress',
    label: 'Username',
    placeholder: 'Your email address (where you received the Welcome email)',
    required: true,
    variant: 'outline' as const,
    type: 'email',
  },
];

interface ResetFormProps {
  onSubmit: (values: { emailAddress: string }) => void;
  loading?: boolean;
  error?: string;
}

export default function ResetForm({ onSubmit, loading, error }: ResetFormProps) {
  return (
    <Container fluid>
      <Card>
        <Row spacing="md">
          <Col size={12}>
            <HeaderText text="Request Password Reset" className="header-text-auth" />
            <BodyText as="p" className="body-text-auth">
              Forgot your password? Enter the email associated with the account to receive a reset password link
            </BodyText>

            {typeof error === 'string' && error.trim().length > MIN_LEN && (
              <BodyText as="p" className="text-destructive mt-2">
                {error}
              </BodyText>
            )}
          </Col>
        </Row>

        <Form
          schema={schema}
          fields={fields}
          onSubmit={onSubmit}
        />
      </Card>
    </Container>
  );
}
